module.exports = __webpack_public_path__ + "static/img/teaching_materials.3b414346.png";